import { render } from "./Welcome.vue?vue&type=template&id=494e8656&scoped=true"
const script = {}

import "./Welcome.vue?vue&type=style&index=0&id=494e8656&lang=scss&scoped=true"

import exportComponent from "/Users/vhstrejo/Sites/crowdfunding/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494e8656"]])

export default __exports__